import PermissionProfileModel from '../../models/manage/PermissionProfileModel.js';

const PermissionProfileCollection = Backbone.Collection.extend({
  name: 'permissionProfiles',
  model: PermissionProfileModel,

  sync(method, collection, options) {
    // For use with jQuery "when" and "then"
    const defer = $.Deferred();
    const promise = defer.promise();
    // Copy the "options" argument minus properties specified in the omit array
    const params = _.omit($.extend(true, {}, options), ['parse', 'success', 'error']);

    options.reset = (options.reset === undefined ? true : options.reset);

    if (method === 'read') {
      return Sendible.Connect.permissionProfiles('', $username, $password, params, (data) => {
        // Success handling
        options.success(data);
        defer.resolve(data);
      }, (data) => {
        // Error handling
        defer.reject(data);
      });
    }
    return promise;
  },

});

export default PermissionProfileCollection;
